import { CloudFrameStack } from "@cloudframe/stack";
import Authorization from "../components/auth/authorization";
import { UserPermission } from "../constants/permissions.constants";
import ContinuumScannerLicenseForm from "../components/continuum-scanner-license/continuum-scanner-license-form";

const CreateContinuumScannerLicensePage = () => {
  return (
    <Authorization>
      <section key={UserPermission.P_CONTINUUM_SCANNER_LICENSE}>
        <div style={{ margin: 16 }}>
          <CloudFrameStack>
            <ContinuumScannerLicenseForm />
          </CloudFrameStack>
        </div>
      </section>
    </Authorization>
  );
};

export default CreateContinuumScannerLicensePage;
